import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=c4214352&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=ts&"
export * from "./terms.vue?vue&type=script&lang=ts&"
import style0 from "./terms.vue?vue&type=style&index=0&id=c4214352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4214352",
  null
  
)

export default component.exports